module.exports = __webpack_public_path__ + "static/img/成功案例2.e523b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/成功案例2.png
// module id = s5bN
// module chunks = 1